import React, {ReactElement} from 'react';
import {setAppBarTitle, setBackNavEnabled} from '../../redux/globalSlice';
import {useAppDispatch, useAppSelector} from '../../redux/hooks';
import {useEffect} from 'react';
import {Getbanner} from './Getbanner';
import {setPageName} from '../../lib/tagmanager';
import {pageName} from '../../lib/constants';

const LMRpromotions = (): ReactElement => {
  useEffect(() => {
    setPageName(pageName.promotionPage);
  }, []);
  useEffect(() => {
    dispatch(setAppBarTitle('Store Promotions'));
    dispatch(setBackNavEnabled(true));
    return () => {
      // Clean up the subscription
      dispatch(setAppBarTitle(''));
      dispatch(setBackNavEnabled(false));
    };
  }, [setAppBarTitle]);
  const dispatch = useAppDispatch();
  return (
    <div className="px-4 py-6">
      <Getbanner />
    </div>
  );
};

export default LMRpromotions;
